export enum ErrorName {
  BLUETOOTH_OFF = 'Bluetooth is off',
  BLUETOOTH_DENIED = 'Bluetooth permission denied',
  LOCATION_DENIED = 'Location permission denied',
  STARTING_FAILED = 'Start manager failed',
  CHARGING_FAILED = 'Wait for charging failed',
  SCANNING_FAILED = 'Scan for chargers failed',
  RANGING_FAILED = 'Ranging for beacons failed',
  CONNECTING_FAILED = 'Connection to charger failed',
  READING_FAILED = 'Reading charger failed',
  WRITING_FAILED = 'Writing charger failed',
  FIRMWARE_FAILED = 'Firmware update failed',
  CHARACTERISTICS_FAILED = 'Charger characteristics incorrect',
  NETWORK_FAILED = 'Device is not attached to the network',
  SENSOR_FAILED = 'Sensor is not connected',
  VALIDATION_FAILED = 'Validation failed',
}

export interface StoreError<T = any> extends Error {
  message: string
  name: ErrorName
  info?: T
}
